import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TimingImpulseModel extends Model 
{
	@attr time;

	@belongsTo('timing-channel', {inverse:null, async: true}) TimingChannelId;
	@belongsTo('event', {inverse: 'timingImpulses', async: true}) EventId;
}